import React from 'react';

export const AppLoaderContextt = React.createContext(null);